import { BASE_BE_URL } from "../../lib/sessionClient";

export const RECEIVER_REJECTED = BASE_BE_URL + "/expense/receiver-rejected-company-expense";
export const verifyRecieverRejected = (id) =>
  `${BASE_BE_URL}/expense/${id}/verify-receiver-rejected-company-expense`;
export const resendRecieverRejectedExpense = (id) =>
  `${BASE_BE_URL}/expense/${id}/resend-receiver-rejected-company-expense`;
